export interface IDashDonorData {
    centerId: number,
    centerAlias: number,
    startedCount: number,
    incompleteScreeningCount: number,
    hardRuleOutCount: number,
    softRuleOutCount: number,
    nonUsRuleOutCount: number,
    manuallyRuledOutCount: number,
    expiredRuleOutCount: number,
    incompleteHistoryCount: number,
    preWorkupLabCount: number,
    atCenterSelectCount: number,
    confirmedDonated: number,
    nddCount: number,
    ddCount: number,
    adpCount: number,
    standardVoucherCount: number,
    familyVoucherCount: number,
    optedOutCount: number,
    notContactedCount: number,
    notContactedWaitAvg: number,
    contactedCount: number,
    workupScheduledCount: number,
    workupCompletedCount: number,
    preOpScheduledCount: number,
    preOpCompletedCount: number,
    surgeryCompletedCount: number,
    inProgressSum: number,
    ruledOutSum: number,
    incompleteSum: number,
    completedAllCount: number,
    notManuallyRuledOut: number,
    completedCount: number,
    cr1RegisteredCount: number,
    cr1ReferredCount: number
}